/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_DutchInputs */



/**
* | output |
* | --- |
* | "Dutch" |
*
* @param {Speechmatics_Target_Language_DutchInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_dutch = /** @type {((inputs?: Speechmatics_Target_Language_DutchInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_DutchInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Neerlandais")
	if (locale === "de") return /** @type {LocalizedString} */ ("Niederländisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("Olandese")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Голландский")
	if (locale === "es") return /** @type {LocalizedString} */ ("Holandés")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("荷兰语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オランダ語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डच")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Holandês")
	return /** @type {LocalizedString} */ ("Dutch")
});